<app-signup *ngIf="!hospitalURL && !schoolURL && !societyURL && !crmURL"></app-signup>

<app-hospital-signup *ngIf="hospitalURL"></app-hospital-signup>

<app-school-signup *ngIf="schoolURL"></app-school-signup>

<app-society-signup *ngIf="societyURL"></app-society-signup>

<app-crm-sign-up *ngIf="crmURL"></app-crm-sign-up>